import { render, staticRenderFns } from "./FullCart.vue?vue&type=template&id=61d1650f&scoped=true"
import script from "./FullCart.vue?vue&type=script&lang=js"
export * from "./FullCart.vue?vue&type=script&lang=js"
import style0 from "./FullCart.vue?vue&type=style&index=0&id=61d1650f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d1650f",
  null
  
)

export default component.exports